import { IconButton } from "@mui/joy";
import { ExportIcon } from "@phosphor-icons/react";

export function ProfileButtonShare({ setShareOpen }) {
    return (
        <IconButton
            variant="soft"
            color="primary"
            onClick={() => setShareOpen(true)}
            sx={(theme) => ({
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '2px',
                px: 2,
                py: 1,
                borderRadius: "999px",
                width: '56px',
                color: theme.palette.mode === 'dark'
                    ? theme.palette.primary[100]
                    : null,
                fontSize: '12px',
                '& svg': {
                    width: '24px',
                    height: '24px',
                }
            })}
        >
            <ExportIcon size={24} />
        </IconButton>
    )
}
